import React from "react";

const PGVendorManageAccount = () => {
  return <div>This is manage account</div>;
};

export default PGVendorManageAccount;
